import React, {useContext, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {Integer} from '@pb/kit-component-formatters';
import {LocaleContext} from '@pb/kit-context-locale';

import {
    userSearchResultLimitsDataSelector,
    userSearchResultLimitsResultSelector,
} from '../../slices/user-search-result-limits.slice';
import {getMappedLimitColumnId} from '../../utils';

type Props = {
    userId: number,
    columnId: string,
};

export const UsedLimitCell = ({userId, columnId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultLimitsDataSelector);
    const result = useSelector(userSearchResultLimitsResultSelector);
    const {locale} = useContext(LocaleContext);

    const mappedColumnId = useMemo(() => getMappedLimitColumnId(columnId), [columnId]);


    const usedLimitValue = useMemo(() => {
        const userLimits = result?.data[userId];

        if (!userLimits) {
            return null;
        }

        const limitItem = userLimits.find(limit => limit.columnId === mappedColumnId);

        if (!limitItem) {
            return null;
        }

        if (limitItem.unlimited) {
            return 'Unlimited';
        }

        return limitItem.value;
    }, [result, userId, mappedColumnId]);

    if (isLoading || loadingError || usedLimitValue === undefined) {
        return null;
    }

    return (
        <span>
            {typeof usedLimitValue === 'number' ? Integer.format(usedLimitValue, locale) : usedLimitValue}
        </span>
    );
};
